import React, { Component } from 'react';
import config from 'react-global-configuration';

import Select from 'react-select';
import getLocale from '../../../i18n/getLocale';
class AirportOperatorLocationsAdd extends Component {

  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'open',
      },
      redirect_url: false,
      loaded: 0,
      active_tpo: 0,
      id: this.props.id,
      airport_operator_locations: [],
    };
    //Handlers
    this.handleLoaded = this.handleLoaded.bind(this);
    this.handleMessage = this.handleMessage.bind(this);
    this.locale = getLocale();
    this.add = this.add.bind(this);
    this.delete = this.delete.bind(this);
  }
  // Handlers  
  handleSelectChange(name, event) {
    var change = {};
    if(event == null) {
      change[name] = null;
    } else {
      change[name] = event.value;
    }
    this.setState(change);
  }
  handleLoaded(state) {
    if(this.state.loaded !== 2) {
      this.setState({loaded: state});
    }
  }

  handleMessage () {
    var message = localStorage.getItem("verify_message");
    if (message !== null && typeof message !== 'undefined') {
      message = JSON.parse(message);
      var self = this;
      self.setState({overlay: {message: message.alert_message, type: message.alert_type, status: 'open'}});
      localStorage.removeItem("verify_message");
    }
  }

  // LM
  componentWillReceiveProps(newProps) {
    if(typeof newProps.id !== "undefined" && (this.state.loaded === 0)) {
      this.setState({id: newProps.id});
    }
    if(Array.isArray(newProps.airport_operator_locations) && Array.isArray(newProps.locations_select) && (this.state.loaded === 0)) {
      this.setState({locations_select: newProps.locations_select, airport_operator_locations: newProps.airport_operator_locations, loaded:1});
    }
  }
  
  // Fetch salvando a edição
  add(event) {
    event.preventDefault();
    this.props.handleAlert('', '', 'open');
    var datasave = {
      airport_operator_id: this.state.id,
      location_id: this.state.location_id,
    };
    var header = this.props.RequestApi.header('application/json');
    var self = this;
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/operador/localidade', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.props.RequestApi.validate(responseJson, 'alert');
        if(responseJson.status === 'success') {
          self.setState({ airport_operator_locations: responseJson.data });
        }
        self.props.handleAlert(responseJson.message, responseJson.status, 'open');
      }).catch((error) => {
        console.error(error);
      });
    });
  }

  delete (event) {
    var airport_operator_location_id = event.currentTarget.value;
    var confirm = window.confirm('Tem certeza que gostaria de deletar essa localidade?');
    if (confirm) {
      this.props.handleAlert('', '', 'open');
      var header = this.props.RequestApi.header('application/json');
      var self = this;
      Promise.resolve(header).then(function(value) {
        fetch(config.get('api') + '/operador/localidade/' + airport_operator_location_id, { method: 'DELETE', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
          self.props.RequestApi.validate(responseJson, 'alert');
          if (responseJson.status === 'success') {
            self.setState({ airport_operator_locations: responseJson.data });
          }
          self.props.handleAlert(responseJson.message, responseJson.status, 'open');
        }).catch((error) => {
          console.error(error);
        });
      });      
    }
  }

  render() {
    var self = this;
    return (
<div>
  <h3>{this.locale.OperadoresAeroporto.EditarOperadoresAeroporto.localidades.titulo}</h3>
  <hr />
  <form onSubmit={this.add}>
    <div className="row">
      <div className="col-md-6">
        <div className="form-group">
          <label>{this.locale.OperadoresAeroporto.EditarOperadoresAeroporto.localidades.formulario.Localidade}:</label>
          <Select
            className="form-field-name"
            name="location_id"
            value={this.state.location_id}
            searchable={true}
            placeholder={this.locale.OperadoresAeroporto.EditarOperadoresAeroporto.localidades.formulario.placeholder.SelecionarLocalidade}
            onChange={this.handleSelectChange.bind(this, 'location_id')}
            options={this.state.locations_select}
            required
          />
        </div>
      </div>
    </div>
    <div>
      <button type="submit" className="btn btn-primary btn-lg btn-block"><i className="fa fa-fw fa-save"></i> {this.locale.OperadoresAeroporto.EditarOperadoresAeroporto.localidades.formulario.botaoAdicionarLocalidade}</button>
    </div>
  </form>
  <hr />
  <div className="table-responsive">
    <table className="table table-bordered table-hover table-striped">
      <thead>
        <tr>
          <th>{this.locale.OperadoresAeroporto.EditarOperadoresAeroporto.localidades.tabela.Localidade}</th>
          <th>{this.locale.OperadoresAeroporto.EditarOperadoresAeroporto.localidades.tabela.Acoes}</th>
        </tr>
      </thead>
      <tbody id="dates">
      {Object.keys(self.state.airport_operator_locations).map(function(k) {
        var airport_operator_location = self.state.airport_operator_locations[k];
        return (
          <tr>
            <td>{airport_operator_location.location.name}</td>
            <td>
              <button className="btn btn-sm btn-danger" value={airport_operator_location.id} onClick={self.delete}>
                <i className="fa fa-fw fa-trash"></i>
              </button>
            </td>
          </tr>
        );
      })}
      </tbody>
    </table>
  </div>
</div>
    );
  }
}

export default AirportOperatorLocationsAdd;



// WEBPACK FOOTER //
// ./src/Components/AirportOperators/Elements/AirportOperatorLocationsAdd.js